import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function PostItem() {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "personal",
    itemType: "lost",
    location: { lat: 0, lng: 0 },
    image: null,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setFormData({
            ...formData,
            location: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          });
        },
        (err) => {
          setError("Geolocation error: " + err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("category", formData.category);
      formDataToSend.append("itemType", formData.itemType);
      formDataToSend.append("lat", formData.location.lat);
      formDataToSend.append("lng", formData.location.lng);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      const response = await axios.post("/api/items", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setSuccess("Item posted successfully!");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(err.response?.data?.error || "An error occurred");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">Post Lost/Found Item</h1>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Item Type</label>
          <div className="flex space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="itemType"
                value="lost"
                checked={formData.itemType === "lost"}
                onChange={handleChange}
                className="text-blue-600"
              />
              <span className="ml-2">Lost</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="itemType"
                value="found"
                checked={formData.itemType === "found"}
                onChange={handleChange}
                className="text-blue-600"
              />
              <span className="ml-2">Found</span>
            </label>
          </div>
        </div>

        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border rounded dark:bg-gray-800"
          />
        </div>

        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            rows="4"
            className="w-full px-4 py-2 border rounded dark:bg-gray-800"
          />
        </div>

        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded dark:bg-gray-800"
          >
            <option value="personal">Personal Items</option>
            <option value="electronics">Electronics</option>
            <option value="documents">Documents</option>
            <option value="clothing">Clothing</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Location</label>
          <div className="flex space-x-2">
            <input
              type="text"
              value={formData.location.lat}
              readOnly
              placeholder="Latitude"
              className="flex-1 px-4 py-2 border rounded dark:bg-gray-800"
            />
            <input
              type="text"
              value={formData.location.lng}
              readOnly
              placeholder="Longitude"
              className="flex-1 px-4 py-2 border rounded dark:bg-gray-800"
            />
            <button
              type="button"
              onClick={handleLocation}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Get Location
            </button>
          </div>
        </div>

        <div>
          <label className="block text-gray-700 dark:text-gray-300 mb-2">Image (Optional)</label>
          <input
            type="file"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
            className="w-full px-4 py-2 border rounded dark:bg-gray-800"
          />
        </div>

        {error && <p className="text-red-500 text-sm">{error}</p>}
        {success && <p className="text-green-500 text-sm">{success}</p>}

        <button
          type="submit"
          className="w-full py-2 bg-black text-white rounded hover:bg-gray-800"
        >
          Post Item
        </button>
      </form>
    </div>
  );
}